import React from 'react';
import { Box, CircularProgress, ThemeProvider } from '@mui/material';
import { AuthProvider, useAuth } from './auth/AuthContext';
import LoginPage from './auth/LoginPage';
import PosGate from './auth/PosGate';
import RegisterPage from './pos/RegisterPage';
import { COLORS, theme } from './pos/theme';

const loadingSx = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: COLORS.pageBg,
} as const;

// No router: the register is one screen. Adding react-router here would
// buy nothing but a dependency and a way to navigate away mid-sale.
const AppShell = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={loadingSx}>
        <CircularProgress size={32} />
      </Box>
    );
  }

  if (!user) return <LoginPage />;

  return (
    <PosGate>
      <RegisterPage />
    </PosGate>
  );
};

const App = () => (
  <ThemeProvider theme={theme}>
    <AuthProvider>
      <AppShell />
    </AuthProvider>
  </ThemeProvider>
);

export default App;
